import { Events, publish } from '../../../pubsub/src/index';

export const chunkArray = (arr, chunkSize) => {
    let index = 0;
    const arrayLength = arr.length;
    const tempArray = [];

    for (index = 0; index < arrayLength; index += chunkSize) {
        const chunk = arr.slice(index, index + chunkSize);
        tempArray.push(chunk);
    }

    return tempArray;
};

export const convertHexToRGBA = (hex, opacity) => {
    const initialHex = hex.replace(/#/, '');
    const r = parseInt(initialHex.substring(0, 2), 16);
    const g = parseInt(initialHex.substring(2, 4), 16);
    const b = parseInt(initialHex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
};

export const handleKeyDown = (handler, codes = [KeyboardCodes.ENTER, KeyboardCodes.SPACE]) => {
    if (!handler) {
        return;
    }

    return e => {
        if (codes.includes(e.keyCode)) {
            handler();
        }
    };
};

export const isMobile = () => {
    return window.matchMedia('(max-width: 668px)').matches;
};

export const calculateDefaultWidgetHeight = () => {
    /* Setting the height of the Default widget is very different from the height of the Wallet */
    let launcherHeight;
    const launchers = document.querySelectorAll('.clx-module__launcher');
    const numberOfLaunchers = launchers ? launchers.length : 0;

    if (numberOfLaunchers === 0) {
        return;
    }

    const firstLauncher = launchers[0];
    const computedLauncherStyle = window.getComputedStyle(firstLauncher);
    const launcherMargin = +computedLauncherStyle.marginTop.replace(/px/, '') * 2;

    /* Set the height according to the height of each launcher and it's top & bottom margin */
    launcherHeight = +computedLauncherStyle.height.replace(/px/, '') + launcherMargin;

    /* Since the open & responsive view is a 2 column grid, we need to determine how many 
       launchers would fit into rows of 2 */
    const rows = Math.ceil(numberOfLaunchers / 2);

    return launcherHeight * rows;
};

export const setWidgetHeight = (yPosition, skin, height) => {
    const MIN_LAUNCHERS = 3;
    const MAX_LAUNCHERS = 5;
    const moduleBar = document.querySelector('#clx-container__module-bar');
    const firstLauncher = [...document.querySelectorAll('.clx-module__launcher')][0];
    const numberOfLaunchers = document.querySelectorAll('.clx-module__launcher').length;

    let wrapperHeight;
    let wrapperHeaderHeight = 0;
    let wrapperFooterHeight = 0;

    const multiplier =
        skin !== ModuleBarSkins.WALLET
            ? numberOfLaunchers
            : numberOfLaunchers >= MAX_LAUNCHERS
            ? MAX_LAUNCHERS
            : numberOfLaunchers <= 3
            ? MIN_LAUNCHERS
            : numberOfLaunchers;

    // Set a sensible default for wrapperHeight
    wrapperHeight = height * multiplier + height / 2;

    if (firstLauncher) {
        const computedStyle = window.getComputedStyle(firstLauncher);
        const margin = +computedStyle.marginTop.replace(/px/, '') + +computedStyle.marginBottom.replace(/px/, '');

        wrapperHeight = height * multiplier + margin * numberOfLaunchers - 1;
    }

    moduleBar.classList.add('opened');

    // Get the computed height of the wallet theme copy section
    if (skin === ModuleBarSkins.WALLET) {
        const moduleHeader = document.querySelector('.clx-container__module-bar__header');
        const moduleFooter = document.querySelector('.clx-container__module-bar__footer');
        wrapperHeaderHeight = moduleHeader.offsetHeight;
        wrapperFooterHeight = moduleFooter.offsetHeight;
    }
    wrapperHeight += wrapperHeaderHeight + wrapperFooterHeight;
    moduleBar.style.height = `${wrapperHeight}px`;

    if (yPosition === 'bottom') {
        moduleBar.style.marginTop = `-${wrapperHeight}px`;
    }

    publish(Events.WALLET_MORE_OPEN, {});
};

export const KeyboardCodes = {
    TAB: 9,
    ENTER: 13,
    SPACE: 32,
    LEFT: 37,
    TOP: 38,
    RIGHT: 39,
    DOWN: 35,
    HOME: 36,
    ESC: 27
};

export const LauncherSize = {
    small: {
        height: 72,
        width: 96
    },
    medium: {
        height: 88,
        width: 104
    },
    large: {
        height: 104,
        width: 120
    }
};

export const ModuleBarSkins = {
    DEFAULT: 'default',
    WALLET: 'skin1'
};
